import { Dispatch, SetStateAction, createContext } from 'react'

import { EditCreditNoteModalEnum } from '@/modules/invoices/types/EditCreditNoteModalEnum'
import { EditInvoiceModalEnum } from '@/modules/invoices/types/EditInvoiceModalEnum'

interface DetailsContextType {
  setModalType?: Dispatch<SetStateAction<string | EditInvoiceModalEnum | EditCreditNoteModalEnum | null>>
  showUpdateButton?: boolean
  tooltip?: boolean
}

export const DetailsContext = createContext<null | DetailsContextType>(null)
